import React from "react";
// local
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {IconCross, IconCheck} from "components/icons";
import {color} from "constants/color.consts";

const AgreementCardSwitch = ({
  isAdminOwner,
  checked,
  onClick,
  activeLabel,
  inactiveLabel,
  inactiveMemberLabel,
  extraIcon,
}) => {
  const ownerLabel = checked ? activeLabel : inactiveLabel;
  const memberLabel = checked ? activeLabel : inactiveMemberLabel;

  return (
    <React.Fragment>
      {isAdminOwner ? (
        <CustomRadioSwitch
          label={ownerLabel}
          checked={checked}
          mediumText
          isDisabledLabel={!checked}
          isActive={onClick}
        />
      ) : (
        <div className="df-row-center">
          {checked ? (
            <IconCheck addClass="mr-2" color={color.green} />
          ) : (
            <IconCross addClass="mr-2 wdth-20" color={color.red} />
          )}
          {extraIcon}
          {memberLabel}
        </div>
      )}
    </React.Fragment>
  );
};

export default AgreementCardSwitch;
